document.addEventListener("DOMContentLoaded", function () {
    if (document.querySelector(".rellax1")) {
        new Rellax(".rellax1");
    }

    if (document.querySelector(".rellax2")) {
        new Rellax(".rellax2");
    }

    if (document.querySelector(".rellax3")) {
        new Rellax(".rellax3");
    }

    if (document.querySelector(".rellax4")) {
        new Rellax(".rellax4");
    }
});

